import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from "date-fns";
import { useEffect, useState } from "react";

interface UseCountdownTimerOptions {
  endDate?: string;
}

const TIMER_INTERVAL = 1000;

export const useCountdownTimer = ({ endDate }: UseCountdownTimerOptions) => {
  const [timeRemaining, setTimeRemaining] = useState("");

  const formatCountdownTimer = (endDateString: string) => {
    const endDateTime = new Date(endDateString);
    const now = new Date();

    if (endDateTime <= now) return "0s";

    const days = differenceInDays(endDateTime, now);
    const hours = differenceInHours(endDateTime, now) % 24;
    const minutes = differenceInMinutes(endDateTime, now) % 60;
    const seconds = differenceInSeconds(endDateTime, now) % 60;

    const isLastHour = days === 0 && hours === 0;

    // Show seconds if less than 1 hour left
    if (isLastHour) {
      return `${minutes}m : ${seconds}s`;
    }

    if (days > 0) {
      return `${days}d : ${hours}h : ${minutes}m`;
    }

    return `${hours}h : ${minutes}m`;
  };

  useEffect(() => {
    if (!endDate) {
      setTimeRemaining("");
      return;
    }

    const updateTimer = () => {
      setTimeRemaining(formatCountdownTimer(endDate));
    };

    updateTimer();
    const interval = setInterval(updateTimer, TIMER_INTERVAL);

    return () => clearInterval(interval);
  }, [endDate]);

  return timeRemaining;
};
